import { render, staticRenderFns } from "./ReturnService1.vue?vue&type=template&id=7ffc4170&"
import script from "./ReturnService1.vue?vue&type=script&lang=ts&"
export * from "./ReturnService1.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnService1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports